import React, { useState, useEffect } from "react";
import campagnePhysiqueService from "./../../../../services/MarketingService/CampagnePhysiqueService"
import { useParams } from "react-router-dom";

function StatCampagnePhysique() {
  const [data, setData] = useState({});

  const [photos, setPhotos] = useState([]);
  const [images, setImages] = useState([]);

  const { id } = useParams();

  const fetchData = async () => {
    try {
      campagnePhysiqueService.getCampagnePhysiqueByID(
        id
      ).then((response) => {
        setData(response.data.success);

      })
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPhotos = async () => {
    try {
      const responsePhotosId =
        await campagnePhysiqueService.getCampagnePhysiquePhotosId(id);
      setPhotos(responsePhotosId.data);
      const fetchedPhotos = await Promise.all(
        responsePhotosId.data.map(async (photoId) => {
          const responsePhotos = await campagnePhysiqueService.showImage(
            photoId
          );
          return responsePhotos;
        })
      );
      setImages(fetchedPhotos);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchPhotos();
  }, [id]);

  return (

    < div className="content-wrapper" style={{ marginTop: "0" }
    }>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Campagne Physique</h1>
            </div>
            <div className="col-sm-6">
              {/* <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Marketing</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne">Campagne</a>
                </li>
                <li className="breadcrumb-item active">Physique</li>
              </ol> */}
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        {/* container-fluid */}
        <div className="container-fluid">
          <div className="col">
            <div className="card card-primary card-outline">
              <div className="card-header">
                <h5 className="m-0">{data && data.nom ? data.nom : ""}</h5>
              </div>
              <div className="card-body">
                <div className="post">
                  <div className="user-block">
                    <img
                      className="img-circle img-bordered-sm"
                      src="../../dist/img/user6-128x128.jpg"
                      alt="User Image"
                    />
                    <span className="username">
                      <a href="#">Iware ERP</a>
                    </span>
                    <span className="description">
                      Posted -{" "}
                      {data && data.createdDate
                        ? new Date(data.datePublication)
                          .toLocaleDateString("fr-FR", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          })
                          .replace(/\//g, "-")
                        : ""}
                    </span>
                  </div>
                  <div className="row mb-3">

                    <div class="w-100"></div>

                    {images.map((image, index) => (
                      <div className="col" key={index}>
                        <img
                          src={image}
                          alt="example"
                          style={{ height: "200px" }}
                        />
                      </div>
                    ))}
                  </div>

                  {/* <p>
                    <a href="#" className="link-black text-sm mr-2">
                      <i className="fas fa-share mr-1"></i> Share (5)
                    </a>
                    <a href="#" className="link-black text-sm">
                      <i className="far fa-thumbs-up mr-1"></i> Like (5)
                    </a>
                    <span className="float-right">
                      <a href="#" className="link-black text-sm">
                        <i className="far fa-comments mr-1"></i> Comments (5)
                      </a>
                    </span>
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div >

  );
}

export default StatCampagnePhysique;
